import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_PUBLISH_CAMPAIGN_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

type SetCampaignPublishedPayload = {
  campaignId: number
  published: boolean
}

export const useSetCampaignPublished = () => {
  const orgId = useSelector(selectOrgId)
  const dispatch = useAppDispatch()
  const [setPublished, res] = esApi.endpoints.setCampaignPublished.useMutation()

  const setCampaignPublished = useCallback(
    async ({ campaignId, published }: SetCampaignPublishedPayload) => {
      try {
        await setPublished({
          orgId: String(orgId),
          campaignId: String(campaignId),
          body: { published },
        }).unwrap()

        dispatch(
          createNotification({
            'publish-campaign': {
              type: 'success',
              message: published ? 'Campaign is now live.' : 'Campaign returned to draft successfully.',
            },
          }),
        )

        return { id: Number(campaignId), published }
      } catch (error) {
        dispatch(
          createNotification({
            'publish-campaign': {
              type: 'error',
              message: getErrorMessage(error, ERROR_PUBLISH_CAMPAIGN_SERVER),
            },
          }),
        )
        return undefined
      }
    },
    [orgId, dispatch, setPublished],
  )

  return [setCampaignPublished, res] as const
}
